let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9hiae")).then(() => parcelRequire('dge6h'));